import { invitationChoiceEndpoint } from "../../utils/api/urls";
import { useApi } from "../../utils/api/useApi";

type InvitationChoice = "accepted" | "rejected";

type ChoiceResult = { ok: true } | { ok: false; code?: string; message?: string; status?: number };

const inferCode = (status?: number, detail?: string, title?: string): string | undefined => {
  const text = `${detail ?? ""} ${title ?? ""}`.toLowerCase();

  if (status === 410) return "invitation_expired";
  if (status === 404) {
    if (text.includes("expired")) return "invitation_expired";
    return "invitation_not_found";
  }
  if (status === 409) {
    if (text.includes("completed") || text.includes("already"))
      return "invitation_already_accepted";
    if (text.includes("cancelled") || text.includes("canceled")) return "invitation_cancelled";
    return "invitation_conflict";
  }

  if (text.includes("expired")) return "invitation_expired";
  if (text.includes("not found")) return "invitation_not_found";
  if (text.includes("cancel")) return "invitation_cancelled";
  if (text.includes("complete")) return "invitation_already_accepted";

  return undefined;
};

export const useInvitationChoice = () => {
  const { patch } = useApi<void>();

  const sendInvitationChoice = async (
    workflowId: string,
    choice: InvitationChoice
  ): Promise<ChoiceResult> => {
    try {
      await patch(invitationChoiceEndpoint, { WorkflowId: workflowId, Choice: choice });
      return { ok: true };
    } catch (err: any) {
      const status = err?.response?.status as number | undefined;
      const data = err?.response?.data;

      const code =
        data?.code ??
        data?.extensions?.code ??
        data?.errors?.[0]?.code ??
        inferCode(status, data?.detail, data?.title);

      const message = data?.detail || data?.title || err?.message || "Error updating invitation";

      return { ok: false, code, message, status };
    }
  };

  return { sendInvitationChoice };
};
